import React, { Component } from "react";
import {
  PageHeader,
  Tag,
  Button,
  Statistic,
  Row,
  Col,
  Dropdown,
  Menu,
  Table,
  Input,
  Space,
  Spin,
  DatePicker,
  Form,
  Select
} from "antd";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { GET, DELETE, UPDATE } from "../constants/request-type";
import { service_api } from "../constants/url";
import {
  order,
  delete_order,
  update_order,
  get_all_order,
  user,
  get_all_user,
  food,
  get_all_food,
  get_all_glocery_item,
  get_all_glocery_partner,
  glocery_item,
  get_all_company_glocery_item
} from "../constants/routes";
import { MakeRequestAsync } from "../functions/axios";
import { openNotificationWithIcon } from "../functions/notification";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import { decryptSingleData, encryptData } from "../functions/cryptojs";
import { google_map_key } from "../constants/mapkey";
import GoogleMapReact from "google-map-react";
import { CSVLink, CSVDownload } from "react-csv";

import startIcon from "../../assets/start.png";
import dest from "../../assets/dest.png";
import bike from "../../assets/bike.png";
import { todayDate } from "../functions/dateFunctions";
import Article_new from "../forms/article_new";
import Article_edit from "../forms/article_edit";

const token = sessionStorage.getItem("auth_token");

const { RangePicker } = DatePicker;

const { Option } = Select;

class GloceryArticle extends Component {
  state = {
    selectedRowKeys: [],
    searchText: "",
    searchedColumn: "",
    load: true,
    data: [],
    data_category: [],
    list: [],
    chef: [],
    chef_selected: null,
    selected_date: todayDate(),
    start: null,
    end: null,
    selected: true,
    overall: true,
    allowed: false,
    blocked: false,
    driver_around: [],
    openModal: false,
    ride_selected: null,
    show: "all",
    rate: null,
    rate_view: false
  };

  componentDidMount() {
    this.getData();
  }

  static defaultProps = {
    center: {
      lat: 43.65107,
      lng: -79.347015
    },
    zoom: 5
  };

  getData = async () => {
    const request_details_category = {
      type: GET,
      url: service_api,
      route: "category" + "/" + "get-actif",
      data: null,
      token: token
    };

    const request_details = {
      type: GET,
      url: service_api,
      route:
        glocery_item +
        "/" +
        get_all_company_glocery_item +
        "/" +
        this.props.admin._id,
      data: null,
      token: token
    };

    const response = await MakeRequestAsync(request_details).catch((err) => {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        `${err?.response?.data?.message}`
      );
    });

    const response_category = await MakeRequestAsync(
      request_details_category
    ).catch((err) => {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        `${err?.response?.data?.message}`
      );
    });

    this.setState({
      load: false,
      data: decryptSingleData(response?.data?.glocery_item),
      data_category: decryptSingleData(response_category?.data?.category)
    });
  };

  // handleStatus = async (id, status) => {
  //   const data = {
  //     status: status
  //   };
  //   const request_details = {
  //     type: UPDATE,
  //     url: service_api,
  //     route: "glocery-item/update-glocery-item-admin/" + id,
  //     data: data,
  //     token: token
  //   };

  //   const response = await MakeRequestAsync(request_details).catch((err) => {
  //     return openNotificationWithIcon("error", `${err.response.data}`);
  //   });
  //   return setTimeout(() => window.location.reload(), 1000);
  // };

  handleVisible = async (id, status) => {
    const data = {
      visible: status
    };
    const request_details = {
      type: UPDATE,
      url: service_api,
      route: "glocery-item/update-glocery-item/" + id,
      data: data,
      token: token
    };

    const response = await MakeRequestAsync(request_details).catch((err) => {
      return openNotificationWithIcon("error", `${err.response.data}`);
    });
    return setTimeout(() => window.location.reload(), 1000);
  };

  handleDelete = async (id, status) => {
    const data = {
      deleted: status
    };
    const request_details = {
      type: UPDATE,
      url: service_api,
      route: "glocery-item/update-glocery-item/" + id,
      data: data,
      token: token
    };

    const response = await MakeRequestAsync(request_details).catch((err) => {
      return openNotificationWithIcon("error", `${err.response.data}`);
    });
    return setTimeout(() => window.location.reload(), 1000);
  };

  onSelectChange = (selectedRowKeys) => {
    console.log("selectedRowKeys changed: ", selectedRowKeys);
    this.setState({ selectedRowKeys });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      )
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  // handleDelete = async (id) => {
  //   const request_details = {
  //     type: DELETE,
  //     url: service_api,
  //     route: order + "/" + delete_order + "/" + id,
  //     token: token
  //   };
  //   const response = await MakeRequestAsync(request_details).catch((err) => {
  //     return openNotificationWithIcon(
  //       "error",
  //       `${err?.response?.data?.message}`
  //     );
  //   });

  //   return setTimeout(() => window.location.reload(), 1000);
  // };

  render() {
    const columns = [
      {
        title: "Id",
        dataIndex: "_id",
        // width: "20%",
        ...this.getColumnSearchProps("_id")
        // fixed: "left"
      },
      {
        title: "Image",
        dataIndex: "pic",
        render: (text) => (
          <a href={text} target="_blank">
            <img
              src={text}
              style={{
                width: 50,
                height: 50,
                objectFit: "contain"
              }}
              alt={"food-img"}
            />
          </a>
        )
      },
      {
        title: "Article name",
        dataIndex: "name",
        render: (text) => <span>{text}</span>
      },
      {
        title: "Other informations",
        dataIndex: "details",
        render: (text, record) => (
          <Tag color="volcano">
            <span>Cost: ${record?.cost}</span>
            <br />
            <span>Unit: {record?.weight_type}</span>
            <br />
            <span>Weight: {record?.weight}</span>
            <br />
          </Tag>
        )
      },
      {
        title: "Description",
        dataIndex: "description",
        width: "20%",
        render: (text) => (
          <Tag color={"purple"}>
            <span>{text}</span>
          </Tag>
        )
      },
      // {
      //   title: "Supprimer",
      //   dataIndex: "deleted",
      //   render: (text) => (
      //     <Tag color={text === false ? "green" : "volcano"}>
      //       <b>
      //         {text === true && "Supprimer"}
      //         {text === false && "Non"}
      //       </b>
      //     </Tag>
      //   )
      // },
      {
        title: "Visible",
        dataIndex: "visible",
        render: (text) => (
          <Tag color={text === false ? "volcano" : "green"}>
            <b>
              {text === true && "Visible"}
              {text === false && "Invisible"}
            </b>
          </Tag>
        )
      },
      {
        title: "Status",
        dataIndex: "status",
        render: (text) => (
          <Tag color={text === false ? "volcano" : "green"}>
            <b>
              {text === true && "Actif"}
              {text === false && "inactif"}
            </b>
          </Tag>
        )
      },
      {
        title: "Actions",
        fixed: "right",
        render: (text, record) => (
          <div>
            <Dropdown
              overlay={MenuButton(record)}
              placement="bottomCenter"
              arrow
            >
              <Button>Options</Button>
            </Dropdown>
          </div>
        )
      }
    ];

    const { selectedRowKeys, allowed, blocked, overall } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
      selections: [
        Table.SELECTION_ALL,
        Table.SELECTION_INVERT,
        Table.SELECTION_NONE,
        {
          key: "odd",
          text: "Select Odd Row",
          onSelect: (changableRowKeys) => {
            let newSelectedRowKeys = [];
            newSelectedRowKeys = changableRowKeys.filter((key, index) => {
              if (index % 2 !== 0) {
                return false;
              }
              return true;
            });
            this.setState({ selectedRowKeys: newSelectedRowKeys });
          }
        },
        {
          key: "even",
          text: "Select Even Row",
          onSelect: (changableRowKeys) => {
            let newSelectedRowKeys = [];
            newSelectedRowKeys = changableRowKeys.filter((key, index) => {
              if (index % 2 !== 0) {
                return true;
              }
              return false;
            });
            this.setState({ selectedRowKeys: newSelectedRowKeys });
          }
        }
      ]
    };

    const MenuButton = (record) => (
      <Menu>
        <Menu.Item>
          <Article_edit row={record} category={data_category} />
        </Menu.Item>
        {record.visible === false ? (
          <Menu.Item>
            <Link onClick={() => this.handleVisible(record._id, true)}>
              Make it visible
            </Link>
          </Menu.Item>
        ) : (
          <Menu.Item>
            <Link onClick={() => this.handleVisible(record._id, false)}>
              Hide it
            </Link>
          </Menu.Item>
        )}

        {/* {record.status === false ? (
          <Menu.Item>
            <Link onClick={() => this.handleStatus(record._id, true)}>
              Activer
            </Link>
          </Menu.Item>
        ) : (
          <Menu.Item>
            <Link onClick={() => this.handleStatus(record._id, false)}>
              Desactiver
            </Link>
          </Menu.Item>
        )} */}

        {record.deleted === false && (
          <Menu.Item>
            <Link onClick={() => this.handleDelete(record._id, true)}>
              Delete
            </Link>
          </Menu.Item>
        )}
      </Menu>
    );

    const AnyReactComponent = ({ long, lat, path }) => (
      <div
        onClick={() => {
          this.setState({ openModal: true });
        }}
      >
        <img src={path} style={{ width: 50, height: 50 }} />
      </div>
    );

    const { load, data, start, data_category, end } = this.state;
    return (
      <>
        <PageHeader
          onBack={() => {
            //  window.history.back()
          }}
          title="Articles"
          tags={<Tag color="blue">List of articles</Tag>}
          subTitle=""
          extra={[
            <RangePicker
              showTime
              onChange={(data) => {
                console.log(data);
                if (data === null) {
                  this.setState({
                    start: null,
                    end: null
                  });
                }
                let d1 = data[0].format("YYYY-MM-DDTHH:mm:ss");
                let d2 = data[1].format("YYYY-MM-DDTHH:mm:ss");

                this.setState({ start: d1, end: d2 });
              }}
            />,
            <Article_new _id={this.props.admin._id} category={data_category} />,
            <CSVLink data={data}>Exporter CSV/Excel</CSVLink>
          ]}
        >
          <Row>
            <Statistic
              title="Total"
              value={
                data?.filter((item) => {
                  if (start === null && end === null) {
                    return item;
                  }
                  return item.createdAt >= start && item.createdAt <= end;
                })?.length
              }
            />
          </Row>

          <Row
            style={{
              marginTop: 20
            }}
          >
            {load ? (
              <Space size="middle">
                <Spin size="large" />
              </Space>
            ) : (
              <Col span={24}>
                <Table
                  rowSelection={rowSelection}
                  // size="small"
                  scroll={{
                    x: "auto"
                  }}
                  columns={columns}
                  dataSource={data?.filter((item) => {
                    if (start === null && end === null) {
                      return item;
                    }
                    return item.createdAt >= start && item.createdAt <= end;
                  })}
                />
              </Col>
            )}
          </Row>
        </PageHeader>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    admin: state.admin
  };
};

const mapDispatchStoreToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchStoreToProps
)(GloceryArticle);
